import React from "react";

const Radio = ({ element }) => {
  return (
    <div style={element.isHorizontal ? { display: "flex", gap: "8px" } : {}}>
      {element.data.values.map((option, index) => (
        <div key={option + index}>
          <input type="radio" name={element.key} value={option.value} id={`${element.key}-${option.value}`} />
          <label htmlFor={`${element.key}-${option.value}`}>{option.label}</label>
        </div>
      ))}
    </div>
  );
};

export default Radio;
